// extracted by mini-css-extract-plugin
export default {"editButton":"addPayroll_editButton__Mg-rE","TableBody":"addPayroll_TableBody__VBU4b","deleteButton":"addPayroll_deleteButton__ioopZ"};